<eazly-header i18n-title="@@Help" title="Help"></eazly-header>

<div class="main container">
  <div class="alert alert-warning" role="alert">
    This is the help page which is still to be implemented.
  </div>
</div>
